import { render, staticRenderFns } from "./FormAgendar.vue?vue&type=template&id=b1ffe74a"
import script from "./FormAgendar.vue?vue&type=script&lang=js"
export * from "./FormAgendar.vue?vue&type=script&lang=js"
import style0 from "./FormAgendar.vue?vue&type=style&index=0&id=b1ffe74a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports